export default __webpack_public_path__ + "static/media/banner_achievements_mobile.330015ee.png";